const TableRecord = () => {
  const tableData = [
    {
      coloumn1name: "Program 1",
      coloumn2name: "Program 1",
      coloumn3name: "7 – 8 years Grade/Year 3 to adults",
    },
    {
      coloumn1name: "Program 2",
      coloumn2name: "Program 2",
      coloumn3name: "8 – 9 years Grade/Year 4 to adults",
    },
    {
      coloumn1name: "Program 3",
      coloumn2name: "Program 3",
      coloumn3name: "9 – 10 years Grade/Year 5 to adults",
    },
    {
      coloumn1name: "Program 4",
      coloumn2name: "Program 4",
      coloumn3name: "10 – 11 years Grade/Year 6 to adults",
    },
    {
      coloumn1name: "N/A",
      coloumn2name: "Program 5",
      coloumn3name: "11 – 12 years Grade/Year 7 to adults",
    },
  ];

  return (
    <div className="flex flex-col items-center w-full px-4 lg:p-4 mt-16 gap-y-8 my-5">
      <div className="w-full lg:w-[90%] overflow-x-auto border border-gray-200 rounded-lg shadow-sm">
        <table className="w-full border-collapse table-auto lg:table-fixed bg-white">
          <thead className="bg-[#F69837] text-black">
            <tr>
              <th className="px-4 py-3 text-left font-semibold text-xs lg:text-base lg:w-80 min-w-[200px]">
                Kitehawk Online
              </th>
              <th className="px-4 py-3 text-center font-semibold text-xs lg:text-base lg:w-64 min-w-[200px]">
                Kitehawk Workbooks
              </th>
              <th className="px-4 py-3 text-center font-semibold text-xs lg:text-base lg:w-64 min-w-[200px]">
                Suitable for Student Age’s
              </th>
            </tr>
          </thead>
          <tbody className="bg-white">
            {tableData.map((item, index) => (
              <tr
                key={index}
                className="border-b last:border-none hover:bg-gray-50 transition-colors"
              >
                <td className="px-4 py-3 text-gray-700 text-xs lg:text-base break-words">
                  {item.coloumn1name}
                </td>
                <td className="px-4 py-3 text-center text-gray-700 text-xs lg:text-base">
                  {item.coloumn2name}
                </td>
                <td className="px-4 py-3 text-center text-gray-700 text-xs lg:text-base">
                  {item.coloumn3name}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Text Section */}
      <p className="w-full lg:w-[90%]  text-sm lg:text-base leading-relaxed text-justify lg:text-left">
        The Kitehawk Learning Spelling & Literacy Program can be used as both, a
        remedial program and a mainstream spelling program. The print program
        has also proved popular as a remedial spelling program for high school
        students and juvenile offenders. <br />
        Graphics, such as pictures of fairies, Humpty Dumpty, etc are avoided,
        so the workbooks and Online Program would prove acceptable to mature age
        students.
      </p>
    </div>
  );
};

export default TableRecord;
